import Axios from 'axios'

export default {
  install (Vue) {
    Vue.mixin({
      methods: {
        fn_IS_USER () {
          if (this.$store.getters.getRoles.indexOf('ROLE_USER') > -1) {
            return true
          }
        },
        fn_IS_ADMIN () {
          if (this.$store.getters.getRoles.indexOf('ROLE_ADMIN') > -1) {
            return true
          }
        },
        fn_IS_SUPER_ADMIN () {
          if (this.$store.getters.getRoles.indexOf('ROLE_SUPER_ADMIN') > -1) {
            return true
          }
        },

        fn_IS_DOCTOR () {
          return this.$store.getters.getRoles.some((role) => /doctor/gi.test(role))
        },

        fn_IS_DOCTOR_FACILITIES () {
          return !this.$store.getters.getRoles.some(
            (role) => role === 'ROLE_DOCTOR_FACILITIES' || role === 'ROLE_DOCTOR_PREMIUM'
          )
        },

        fn_GET_DOCTOR_ROLES () {
          return this.$store.getters.getRoles
        },

        fn_IS_SECRETARY () {
          if (this.$store.getters.getRoles.indexOf('ROLE_SECRETARY') > -1) {
            return true
          }
        },
        fn_IS_ACCESS_MEDICAL_CONSULTATION () {
          if (this.$store.getters.getRoles.indexOf('ROLE_ACCESS_MEDICAL_CONSULTATION') > -1) {
            return true
          }
        },
        fn_IS_ACCESS_FINANCIAL_STATEMENT () {
          if (this.$store.getters.getRoles.indexOf('ROLE_ACCESS_FINANCIAL_STATEMENT') > -1) {
            return true
          }
        },
        fn_IS_ACCESS_MEDICAL_PROCEDURE () {
          if (this.$store.getters.getRoles.indexOf('ROLE_ACCESS_MEDICAL_PROCEDURE') > -1) {
            return true
          }
        },
        fn_IS_ACCESS_HISTORY () {
          if (this.$store.getters.getRoles.indexOf('ROLE_ACCESS_HISTORY') > -1) {
            return true
          }
        },
        fn_IS_ACCESS_PATIENT () {
          if (this.$store.getters.getRoles.indexOf('ROLE_ACCESS_PATIENT') > -1) {
            return true
          }
        },
        fn_IS_ACCESS_AGENDA () {
          if (this.$store.getters.getRoles.indexOf('ROLE_ACCESS_AGENDA') > -1) {
            return true
          }
        },
        fn_IS_ACCESS_PANEL () {
          if (this.$store.getters.getRoles.indexOf('ROLE_ACCESS_PANEL') > -1) {
            return true
          }
        },
        fn_IS_TABLET () {
          return this.$store.getters.getViewport.name === 'tablet'
        },
        fn_IS_MOBILE () {
          return this.$store.getters.getViewport.name === 'mobile'
        },
        fn_LOG (v) {
          console.log(v)
        },
        fn_HTTP_CANCEL () {
          this.$store.getters.getCancelToken.cancel('canceled')
          this.$store.dispatch('setCancelToken', this.$http.CancelToken.source())
        },
        fn_CHECK_AUTH () {
          return this.$store.getters.$_checkAuth
        },
        fn_SHOW_PROGRESS () {
          this.$store.dispatch('toggleProgress', true)
        },
        fn_HIDE_PROGRESS () {
          this.$store.dispatch('toggleProgress', false)
        },
        fn_GET_PARENT_ROUTE (route, offset, uppercase) {
          let str = offset ? route.name.replace(offset, '') : route.name
          str = uppercase ? (str[0] + str.split(/[A-Z0-9]/g)[1]) : (str[0] + str.split(/[A-Z0-9]/g)[1]).toLowerCase()
          if (!route.params) {
            return str
          }
          str = (route.path.indexOf('doctorId') > -1 || route.params.doctorId) ? `secretary/doctor/${route.params.doctorId}${str === 'secretary' ? '' : str}` : str
          return str
        },
        fn_GET_CHILD_ROUTES (route) {
          for (let parentRoute in this.$router.options.routes) {
            if (this.$router.options.routes[parentRoute].name === route) {
              return this.$router.options.routes[parentRoute].children
            }
          }
        },
        fn_ACTIVE_CLASS (haystack, needle) {
          if (haystack === needle) {
            return 'active'
          }
        },
        fn_GO_BACK () {
          this.$router.go(-1)
        },
        fn_NUMBERS_ONLY (v) {
          if (!v) return ''
          return v.replace(/[-./() ]/g, '')
        },
        fn_COPY_ARRAY (arr) {
          return Object.assign([], arr)
        },
        fn_COPY_OBJECT (obj) {
          return JSON.parse(JSON.stringify(obj))
        },
        fn_FIND_UF_CODE (uf) {
          for (let i of this.UFS) {
            if (i.name === uf) {
              return i
            }
          }
        },
        fn_ARRAY_FIND_BY (arr, field, value, key) {
          let n = 0
          for (let i of arr) {
            if (i[field] === value) {
              if (key) {
                return n
              } else {
                return i
              }
            }
            n++
          }
        },
        fn_REMOVE_FROM_ARRAY (arr, needle, field, index) {
          let newArr = []
          let i = 0
          for (let item of arr) {
            if (field) {
              if (item[field] !== needle) {
                newArr.push(item)
              }
            } else if (index) {
              if (i !== needle) {
                newArr.push(item)
              }
            } else {
              if (item !== needle) {
                newArr.push(item)
              }
            }
            i++
          }
          return newArr
        },
        fn_REMOVE_ACCENTS (v) {
          let strAccents = v.split('')
          let strAccentsOut = []
          let strAccentsLen = strAccents.length
          let accents = 'ÀÁÂÃÄÅàáâãäåÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž'
          let accentsOut = 'AAAAAAaaaaaaOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz'
          for (let y = 0; y < strAccentsLen; y++) {
            if (accents.indexOf(strAccents[y]) !== -1) {
              strAccentsOut[y] = accentsOut.substr(accents.indexOf(strAccents[y]), 1)
            } else {
              strAccentsOut[y] = strAccents[y]
            }
          }
          strAccentsOut = strAccentsOut.join('')
          return strAccentsOut
        },
        fn_PROCEDURES_STATUS_CLASS (status) {
          switch (status) {
            case 'ABERTO':
              return 'label-open'
            case 'EM ANDAMENTO':
              return 'label-progress'
            case 'CANCELADO PELO PACIENTE':
              return 'label-canceled'
            case 'CANCELADO PELO MÉDICO':
              return 'label-canceled'
            case 'NÃO COMPARECEU':
              return 'label-not-attend'
            case 'REALIZADO':
              return 'label-performed'
            case 'REAGENDADO':
              return 'label-rescheduled'
            default:
              return 'label-primary'
          }
        },
        fn_SORT_LISTENERS () { // adiciona os listeners nos botões de sort para ordenação com API
          setTimeout(
            () => {
              let sorts = document.getElementsByClassName('sort')
              for (let sort of sorts) {
                sort.addEventListener('click', (ev) => {
                  let sort = {
                    field: this.$refs.datatable.sort_by.field,
                    direction: this.$refs.datatable.sort_dir
                  }
                  this.$emit('sort', {
                    field: this.$refs.datatable.sort_by.field,
                    direction: this.$refs.datatable.sort_dir
                  })
                })
              }
            }, 500
          )
        },
        fn_SORT_TABLE (self, sort, tableName = 'datatable') { // (self = o componente pai onde se encontra a datatable, sort = {field, direction}, tablename = nome da REF da datatable)
          setTimeout(() => { // precisa esperar o DOM carregar o componente
            let childIndex = 0
            let colIndex = null
            for (let child of self.$children) {
              if (child.$refs[tableName]) {
                for (let col in child.$refs[tableName].normalized_columns) {
                  if (child.$refs[tableName].normalized_columns[col].field === sort.field && sort.direction) {
                    colIndex = col
                  } else if (child.$refs[tableName].normalized_columns[col].field === 'index' && !sort.direction) {
                    colIndex = col // voltar por ordenação com id quando não há parametro
                  }
                }
              } else {
                childIndex += 1
              }
            }
            // método de ordenação do datatables (precisa da referência interna da coluna)
            self.$children[childIndex].$refs[tableName].setSortDirectionForColumn(sort.direction || 'asc', self.$children[childIndex].$refs[tableName].normalized_columns[colIndex])
          }, 500)
        },
        fn_VALID_PASSWORD (pw) {
          if (!pw) {
            return false
          }
          if (pw.search(/[0-9]/g) === -1 || pw.search(/[a-zA-Z]/g) === -1) {
            return false
          }
          return true
        },
        fn_VALID_CPF (cpf) {
          if (cpf) {
            cpf = cpf.replace(/[^\d]+/g, '')
            if (!cpf) {
              return false
            }
            // Elimina CPFs invalidos conhecidos
            if (cpf.length !== 11 ||
              cpf === '00000000000' ||
              cpf === '11111111111' ||
              cpf === '22222222222' ||
              cpf === '33333333333' ||
              cpf === '44444444444' ||
              cpf === '55555555555' ||
              cpf === '66666666666' ||
              cpf === '77777777777' ||
              cpf === '88888888888' ||
              cpf === '99999999999') {
              return false
            }
            // Valida 1o digito
            let add = 0
            for (let i = 0; i < 9; i++) {
              add += parseInt(cpf.charAt(i)) * (10 - i)
            }
            let rev = 11 - (add % 11)
            if (rev === 10 || rev === 11) {
              rev = 0
            }
            if (rev !== parseInt(cpf.charAt(9))) {
              return false
            }
            // Valida 2o digito
            add = 0
            for (let i = 0; i < 10; i++) {
              add += parseInt(cpf.charAt(i)) * (11 - i)
            }
            rev = 11 - (add % 11)
            if (rev === 10 || rev === 11) {
              rev = 0
            }
            if (rev !== parseInt(cpf.charAt(10))) {
              return false
            }
            return true
          }
          return true
        },
        fn_VALID_CNPJ (cnpj) {
          if (!cnpj) {
            return false
          }
          cnpj = cnpj.replace(/[^\d]+/g, '')

          if (cnpj === '') return false

          if (cnpj.length !== 14) { return false }

          // Elimina CNPJs invalidos conhecidos
          if (cnpj === '00000000000000' ||
                cnpj === '11111111111111' ||
                cnpj === '22222222222222' ||
                cnpj === '33333333333333' ||
                cnpj === '44444444444444' ||
                cnpj === '55555555555555' ||
                cnpj === '66666666666666' ||
                cnpj === '77777777777777' ||
                cnpj === '88888888888888' ||
                cnpj === '99999999999999') { return false }

          // Valida DVs
          let tamanho = cnpj.length - 2
          let numeros = cnpj.substring(0, tamanho)
          let digitos = cnpj.substring(tamanho)
          let soma = 0
          let pos = tamanho - 7
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--
            if (pos < 2) { pos = 9 }
          }
          let resultado = soma % 11 < 2 ? 0 : 11 - soma % 11

          if (resultado !== parseInt(digitos.charAt(0))) { return false }
          tamanho = tamanho + 1
          numeros = cnpj.substring(0, tamanho)
          soma = 0
          pos = tamanho - 7
          for (let i = tamanho; i >= 1; i--) {
            soma += numeros.charAt(tamanho - i) * pos--
            if (pos < 2) { pos = 9 }
          }
          resultado = soma % 11 < 2 ? 0 : 11 - soma % 11
          if (resultado !== parseInt(digitos.charAt(1))) { return false }

          return true
        },
        fn_FORMAT_CURRENCY (ev, priceObj) {
          ev.target.value = ev.target.value ? ev.target.value : 0
          let key = ev.keyCode || ev.charCode
          if (key === 9) { // bypassing tab
            return
          }
          ev.preventDefault()
          if (!Number.isInteger(parseInt(ev.key))) { // delete and backspace. keydown only
            if (key === 8 || key === 46) {
              ev.target.value = parseInt(ev.target.value.replace(/[.,]/g, '')).toString() // remove leading zeroes
              ev.target.value = ev.target.value.substring(0, ev.target.value.length - 1) || 0
              priceObj.raw = parseInt(ev.target.value) / 100
              ev.target.value = this.$filters.TO_BRL(ev.target.value)
              priceObj.converted = ev.target.value
            }
          } else {
            ev.target.value = parseInt(ev.target.value.replace(/[.,]/g, '')).toString() // remove leading zeroes
            ev.target.value += ev.key
            priceObj.raw = parseInt(ev.target.value) / 100
            ev.target.value = this.$filters.TO_BRL(ev.target.value)

            if (ev.target.value.length > 9) {
              ev.target.value = ev.target.value.substring(1)
            }

            priceObj.converted = ev.target.value
          }
        },
        fn_IS_OBJ (v) {
          if (Object.prototype.toString.call(v) === '[object Object]') {
            return true
          }
        },
        fn_BUILD_API_ERRORS (form) {
          let obj = {}
          for (let field in form) {
            obj[field] = []
          }
          return obj
        },
        fn_TO_CAMELCASE (s) {
          return s.replace(/(_\w)/g, function (m) { return m[1].toUpperCase() })
        },
        fn_UCFIRST (s) {
          return typeof s !== 'string' ? '' : s.charAt(0).toUpperCase() + s.slice(1)
        },
        fn_TO_FORM_DATE (s) {
          let str = s.split('/')
          return str.reverse().join('-')
        },
        fn_FROM_SERVER_DATE (s) {
          let str = s.split('T')
          return str[0].split('-').reverse().join('/')
        },
        fn_TO_WEEKDAY (s) {
          let weekdays = {
            'domingo': 'Sunday',
            'segunda': 'Monday',
            'terça': 'Tuesday',
            'quarta': 'Wednesday',
            'quinta': 'Thursday',
            'sexta': 'Friday',
            'sábado': 'Saturday'
          }
          return weekdays[s.toLowerCase()]
        },
        fn_FROM_WEEKDAY (s) {
          let weekdays = {
            'Sunday': 'domingo',
            'Monday': 'segunda',
            'Tuesday': 'terça',
            'Wednesday': 'quarta',
            'Thursday': 'quinta',
            'Friday': 'sexta',
            'Saturday': 'sábado'
          }
          if (!weekdays[s]) {
            for (let day in weekdays) {
              if (weekdays[day] === s) {
                return weekdays[day]
              }
            }
          }
          return weekdays[s]
        },
        fn_GET_AVATAR (user) {
          if (!user) {
            return require(`@/assets/img/m_default.png`)
          }
          let image = user.profile_picture
          if (!image) {
            const gender = user.gender ? user.gender : 'M'
            return require(`@/assets/img/${gender.toLowerCase()}_default.png`)
          } else {
            return `${process.env.ROOT_API}/s3/file/user/${user.id}/profile_picture`
          }
        },
        fn_FIND_MONTH (v, en) {
          if (Number.isInteger(v)) {
            for (let key in this.MONTHS) {
              if (parseInt(key) === v) {
                if (en) {
                  return this.MONTHS[key].split(' | ')[1]
                } else {
                  return this.MONTHS[key].split(' | ')[0]
                }
              }
            }
          }
          for (let key in this.MONTHS) {
            if (this.MONTHS[key].indexOf(v) > -1) {
              return key
            }
          }
        },
        fn_FLATTEN_OBJECT (obj) {
          const self = this
          let newObj = {}
          let propname = ''
          let index = Object.keys(obj)
          let i = 0
          const promise = new Promise(function (resolve) {
            function iterate (obj, propName) {
              for (let prop in obj) {
                propname = propName ? self.fn_TO_CAMELCASE(propName + '.' + prop) : self.fn_TO_CAMELCASE(prop)
                if (self.fn_IS_OBJ(obj[prop]) || prop === 'children') {
                  iterate(obj[prop], propname)
                } else {
                  newObj[propname] = obj[prop]
                }
                if (i === index.length - 1) {
                  resolve(newObj)
                }
                i++
              }
            }
            iterate(obj)
          })
          return promise
        },
        fn_EXPAND_OBJECT (obj) {
          function iterateField (obj, field, value) {
            let parts = field.split('.')
            let o = obj
            if (parts.length > 1) {
              for (let i = 0; i < parts.length - 1; i++) {
                if (!o[parts[i]]) {
                  o[parts[i]] = {}
                }
                o = o[parts[i]]
              }
            }
            o[parts[parts.length - 1]] = value
          }
          let newObj = {}
          for (let field in obj) {
            iterateField(newObj, field, obj[field].value)
          }
          return newObj
        },
        fn_SEARCH_ERRORS (obj, apiErrors) {
          for (let field in obj) {
            apiErrors[field.split('.errors')[0]] = obj[field]
          }
        },
        fn_RESET_REQUESTS (message) {
          this.$store.getters.getCancelToken.cancel(message || 'canceled')
          this.$store.dispatch('setCancelToken', Axios.CancelToken.source())
        },
        fn_IS_OBJECT_EMPTY (obj) {
          return (Object.keys(obj).length === 0 && obj.constructor === Object)
        },

        fn_GET_DOCTOR () {
          let url = ''
          this.doctorId = null
          if (this.fn_IS_SECRETARY()) {
            this.doctorId = parseInt(this.$route.params.doctorId)
            if (!this.doctorId) {
              this.$router.replace('/secretary/doctor_select')
            }
            url = `secretary/doctor/${this.doctorId}`
          } else {
            url = `/doctor`
          }
          return this.$http
            .get(url, this.$store.getters.getAuthHeader)
            .then(res => res.data)
        },

        fn_HANDLE_ERROR (err) {
          const findErrorMessage = (object) => {
            let errorMessage = null

            const recursiveSearch = (object) => {
              for (let value in object) {
                if (value === 'errors') {
                  errorMessage = object[value]
                  break
                } else {
                  recursiveSearch(object[value])
                }
              }
            }

            if (Array.isArray(object)) {
              object.forEach((element) => {
                if (typeof element === 'object') {
                  recursiveSearch(element)
                } else {
                  errorMessage = element
                }
              })
            } else {
              recursiveSearch(object)
            }

            return errorMessage
          }

          const msg = (typeof err !== 'object')
            ? err
            : ('errors' in err)
              ? findErrorMessage(err.errors)
              : 'Ocorreu um erro.'

          this.$store.dispatch('setModalAlert', {
            title: 'Erro',
            body: Array.isArray(msg) ? msg[0] : msg,
            size: 'md',
            active: true
          })
        },

        fn_GET_OFFICES (id = null) {
          return new Promise((resolve, reject) => {
            this.$http
              .get('/doctor', this.$store.getters.getAuthHeader)
              .then((res) => {
                const facetofaceOffices = res.data['doctor_offices']
                  .filter(o => /facetoface/gi.test(o.type))

                const telemedicineOffices = res.data['doctor_offices']
                  .filter(o => /telemedicine/gi.test(o.type))

                const officeId = id || facetofaceOffices[0].id

                this.$store.dispatch('setUserOffices', [...facetofaceOffices, ...telemedicineOffices] || [])
                this.$store.dispatch('setCurrentOffice', officeId || null)

                resolve()
              })
              .catch(reject)
          })
        }
      }
    })
  }
}
